import {gql} from "@irati/utils/gql"

export default gql`
  mutation SetMyBillingUnit($teamId: ID!) {
    setMyBillingUnit(teamId: $teamId)
  }
`
